// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPopUp_wrapper__tzqQO","products":"SearchPopUp_products__tySJc"};